// extracted by mini-css-extract-plugin
export var header = "_t6-1";
export var maskBottom = "_t6-6";
export var maskMiddle = "_t6-7";
export var maskTop = "_t6-5";
export var root = "_t6-0";
export var scrollDownButton = "_t6-3";
export var scrollDownButtonHidden = "_t6-4";
export var viewport = "_t6-2";